import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth debe ser usado dentro de un AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  // Verificar si hay un usuario guardado en localStorage al cargar
  useEffect(() => {
    const checkSession = async () => {
      const savedUser = localStorage.getItem('checkin24_user');
      const sessionId = localStorage.getItem('sessionId');
      
      if (savedUser && sessionId) {
        try {
          const userData = JSON.parse(savedUser);
          
          // Verificar si la sesión sigue siendo válida
          const response = await fetch(`http://localhost:3003/api/auth/session/${sessionId}`);
          const result = await response.json();
          
          if (result.success) {
            setUser(userData);
            setIsAuthenticated(true);
          } else {
            // Sesión inválida o expirada
            console.log('Sesión expirada o inválida');
            localStorage.removeItem('checkin24_user');
            localStorage.removeItem('sessionId');
            localStorage.removeItem('userId');
          }
        } catch (error) {
          console.error('Error al verificar sesión:', error);
          localStorage.removeItem('checkin24_user');
          localStorage.removeItem('sessionId');
          localStorage.removeItem('userId');
        }
      }
      setIsLoading(false);
    };
    
    checkSession();
  }, []);

  const login = (userData) => {
    setUser(userData);
    setIsAuthenticated(true);
    localStorage.setItem('checkin24_user', JSON.stringify(userData));
  };

  const logout = async () => {
    const sessionId = localStorage.getItem('sessionId');
    
    // Cerrar sesión en el servidor si existe sessionId
    if (sessionId) {
      try {
        await fetch('http://localhost:3003/api/auth/logout', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ sessionId })
        });
      } catch (error) {
        console.error('Error al cerrar sesión en el servidor:', error);
      }
    }
    
    // Limpiar estado local
    setUser(null);
    setIsAuthenticated(false);
    localStorage.removeItem('checkin24_user');
    localStorage.removeItem('sessionId');
    localStorage.removeItem('userId');
  };

  const value = {
    user,
    isAuthenticated,
    isLoading,
    login,
    logout
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;